import { createContext, useState } from 'react'
export const checkContext = createContext()
export function CheckContextProvider ({children}) {
    const [checka, setChecka] = useState([])
    return (
        <checkContext.Provider value={{setChecka, checka}}>
            {children}
        </checkContext.Provider>
    )
}